import {
  SAVE_ALL_KHEDMAT,
  SAVE_ALL_KHEDMATSYS,
  KHADAMAT_SEARCH,
} from "Stores/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  khedmatData: [],
  khedmatSys: [],
  khedmatDataPagination: { Limit: 10, Page: 1, Total: 0 },
  khedmatDataSearch: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_ALL_KHEDMAT:
      return updateObject(state, {
        khedmatData: action.khedmatData,
        khedmatDataPagination: action.khedmatDataPagination,
      });
    case KHADAMAT_SEARCH:
      return updateObject(state, {
        khedmatDataSearch: action.khedmatDataSearch,
      });
    case SAVE_ALL_KHEDMATSYS:
      return updateObject(state, {
        khedmatSys: action.khedmatSys,
      });
    default:
      return state;
  }
};

export default reducer;
